import Center from '@components/common/alignment/Center';
import React from 'react';

const ComingSoon: React.FC = () => {
  return (
    <Center>
      <p className='text-7xl font-raleway font-medium text-coffee'>This feature is coming soon!</p>
    </Center>
  );
};

export default ComingSoon;
